import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Descriptions, Divider, Tag, Button, Row, Col, List, Modal, Image, Space, Card, Collapse, Typography, Tooltip } from 'antd'
import { EditOutlined, DeleteOutlined, PlusOutlined, MedicineBoxOutlined, UserOutlined, FolderOutlined, FileImageOutlined, SwapOutlined } from '@ant-design/icons';
import { checkPermission } from '@/utils/permission';
import { isValidDate, RenderCustomerServiceStatus } from '@/utils/helpers';
import CustomerServiceAddForm from '../customer-services/CustomerServiceAddForm';
import CustomerServiceEditForm from '../customer-services/CustomerServiceEditForm';
import HtmlParser from 'react-html-parser';
import NumberFormat from 'react-number-format';
import { getSpecificService, removeService } from '@/redux/actions/CustomerServicesActions';
import ExpandableText from '@/components/ExpandableText';
import CustomerServiceConvertForm from '../customer-services/CustomerServiceConvertForm';

const { confirm } = Modal;
const { Panel } = Collapse;
const { Text } = Typography;

class CustomerServicesList extends Component {
    constructor() {
        super();
        this.state = {
            isOpenEditForm: false,
            isOpenConvertForm: false,
            isOpenAddForm: false,
            currentData: null
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    toggleOpenEditForm(isOpenEditForm, currentData = null) {
        this.setState({
            isOpenEditForm: isOpenEditForm,
            currentData: currentData,
            currentCustomer: this.props.currentItem
        });
    }

    toggleOpenConvertForm(isOpenConvertForm, currentData = null) {
        this.setState({
            isOpenConvertForm: isOpenConvertForm,
            currentData: currentData,
            currentCustomer: this.props.currentItem
        });
    }

    toggleOpenForm(isOpenAddForm) {
        this.setState({
            isOpenAddForm: isOpenAddForm,
            currentCustomer: this.props.currentItem
        });
    }

    onEdit(id) {
        this.props.getSpecificService(id).then(res => {
            this.toggleOpenEditForm(true, res);
        })
    }

    onConvert(id) {
        this.props.getSpecificService(id).then(res => {
            this.toggleOpenConvertForm(true, res);
        })
    }

    openRemove(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeService(id).then(() => {
                setTimeout(() => {
                    this.props.reloadData();
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    render() {
        var { currentData, isOpenAddForm, isOpenConvertForm, isOpenEditForm, currentCustomer } = this.state;
        var { currentItem } = this.props;

        return (
            <div>
                {
                    checkPermission('customer_services', 'list') ? (
                        <>
                            <Row justify="end" className='mb-1'>
                                <Button
                                    disabled={!checkPermission('customer_services', 'create')}
                                    type="dashed"
                                    className='color-blue'
                                    size='small'
                                    onClick={() => this.toggleOpenForm(true)}
                                    icon={<PlusOutlined />}>
                                    Thêm mới
                                </Button>
                            </Row>

                            {currentItem.services_selected && currentItem.services_selected.length > 0 ? (
                                <Row gutter={16}>
                                    {
                                        currentItem.services_selected.map((item, index) => {
                                            const isTransferred = !!item.is_transferred; // true nếu đã chuyển sang dịch vụ khác

                                            return (
                                                <Col key={index} xs={24} md={12} lg={8}
                                                    className={`box-item-service customer-info-data mb-3 ${isTransferred ? 'card-disabled' : ''}`}
                                                >
                                                    <Card
                                                        size="small"
                                                        className="custom-card-actions card-fixed-actions"
                                                        title={
                                                            <div className="flex items-center gap-2 overflow-hidden text-ellipsis whitespace-nowrap">
                                                                <MedicineBoxOutlined /> {item.service_name}
                                                                {item.converted_from_service_name && (
                                                                    <Tooltip title={`Được chuyển từ: ${item.converted_from_service_name}`}>
                                                                        <Tag color="green" className="ml-2">Được chuyển từ: {item.converted_from_service_name}</Tag>
                                                                    </Tooltip>
                                                                )}
                                                                {isTransferred && item.converted_to_service_name && (
                                                                    <Tooltip title={`Đã chuyển sang: ${item.converted_to_service_name}`}>
                                                                        <Tag color="red" className="ml-2">Đã chuyển sang: {item.converted_to_service_name}</Tag>
                                                                    </Tooltip>
                                                                )}
                                                            </div>
                                                        }
                                                        style={{ background: '#e7ecd8' }}
                                                        actions={[
                                                            checkPermission('customer_services', 'update') && (
                                                                <Tooltip title="Chỉnh sửa thông tin dịch vụ" key="edit">
                                                                    <span
                                                                        className={isTransferred ? 'disabled-action' : 'item-action-btn'}
                                                                        onClick={!isTransferred ? () => this.onEdit(item.id) : undefined}
                                                                        style={{ cursor: isTransferred ? 'not-allowed' : 'pointer' }}
                                                                    >
                                                                        <EditOutlined /> Sửa
                                                                    </span>
                                                                </Tooltip>
                                                            ),
                                                            // checkPermission('customer_services', 'convert_to_service') && (
                                                            //     <Tooltip title="Chuyển đổi dịch vụ sang dịch vụ khác" key="convert">
                                                            //         <span
                                                            //             className={isTransferred ? 'disabled-action' : 'item-action-btn'}
                                                            //             onClick={!isTransferred ? () => this.onConvert(item.id) : undefined}
                                                            //             style={{ cursor: isTransferred ? 'not-allowed' : 'pointer' }}
                                                            //         >
                                                            //             <SwapOutlined /> Chuyển đổi
                                                            //         </span>
                                                            //     </Tooltip>
                                                            // ),
                                                            checkPermission('customer_services', 'remove') && (
                                                                <Tooltip title="Xóa dịch vụ khỏi Khách hàng" key="delete">
                                                                    <span
                                                                        className={`delete-icon ${isTransferred ? 'disabled-action' : ''}`}
                                                                        onClick={!isTransferred ? () => this.openRemove([item.id]) : undefined}
                                                                        style={{ cursor: isTransferred ? 'not-allowed' : 'pointer' }}
                                                                    >
                                                                        <DeleteOutlined /> Xóa
                                                                    </span>
                                                                </Tooltip>
                                                            )
                                                        ].filter(Boolean)}

                                                    >
                                                        <Row gutter={16}>
                                                            <Col xs={24} md={24}>
                                                                <Descriptions size="small">
                                                                    <Descriptions.Item label="Giá bán">
                                                                        <NumberFormat value={item.sale_price} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                                <Divider className='no-margin' />
                                                                <Descriptions size="small">
                                                                    <Descriptions.Item label="Số lượng">
                                                                        <NumberFormat value={item.quantity} displayType={'text'} thousandSeparator={true} />
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                                <Divider className='no-margin' />
                                                                <Descriptions size="small">
                                                                    <Descriptions.Item label="Thành tiền">
                                                                        <NumberFormat value={item?.amount} displayType={'text'} suffix="đ" thousandSeparator={true} />
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                                <Divider className='no-margin' />
                                                                <Descriptions size="small">
                                                                    <Descriptions.Item label="Ngày chốt">
                                                                        {isValidDate(item?.selected_at, false)}
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                                <Divider className='no-margin' />
                                                                <Descriptions size="small">
                                                                    <Descriptions.Item label="Trạng thái">
                                                                        {RenderCustomerServiceStatus(item?.status)}
                                                                    </Descriptions.Item>
                                                                </Descriptions>
                                                                <Divider className='no-margin' />
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16} className='customer-service-box'>
                                                            <Col xs={24} md={24}>
                                                                <Collapse
                                                                    expandIconPosition="end"
                                                                    ghost
                                                                    defaultActiveKey={[]}
                                                                >
                                                                    <Panel
                                                                        header={<><span className="font-weight-500"><FileImageOutlined /> Ảnh</span></>}
                                                                        key="1"
                                                                    >
                                                                        <Row gutter={16}>
                                                                            <Col xs={24} md={24} className='mb-2'>
                                                                                <div className='font-weight-500'>Ảnh before</div>
                                                                                {
                                                                                    Array.isArray(item.condition_before) && item.condition_before.length ? (
                                                                                        <Image.PreviewGroup>
                                                                                            <Space wrap>
                                                                                                {
                                                                                                    item.condition_before.map((item, index) => {
                                                                                                        return (
                                                                                                            <Image
                                                                                                                key={index}
                                                                                                                height={40}
                                                                                                                width={40}
                                                                                                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                                                                                                src={item?.src}
                                                                                                            />
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </Space>
                                                                                        </Image.PreviewGroup>
                                                                                    ) : (
                                                                                        <div style={{ textAlign: 'center', width: '100%' }} className='no-data'>Chưa có dữ liệu</div>
                                                                                    )
                                                                                }
                                                                            </Col>
                                                                            <Col xs={24} md={24}>
                                                                                <div className='font-weight-500'>Ảnh after</div>
                                                                                {
                                                                                    Array.isArray(item.condition_after) && item.condition_after.length ? (
                                                                                        <Image.PreviewGroup>
                                                                                            <Space wrap>
                                                                                                {
                                                                                                    item.condition_after.map((item, index) => {
                                                                                                        return (
                                                                                                            <Image
                                                                                                                key={index}
                                                                                                                height={40}
                                                                                                                width={40}
                                                                                                                style={{ objectFit: 'cover', objectPosition: 'center' }}
                                                                                                                src={item?.src}
                                                                                                            />
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </Space>
                                                                                        </Image.PreviewGroup>
                                                                                    ) : (
                                                                                        <div style={{ textAlign: 'center', width: '100%' }} className='no-data'>Chưa có dữ liệu</div>
                                                                                    )
                                                                                }
                                                                            </Col>
                                                                        </Row>
                                                                    </Panel>
                                                                </Collapse>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16} className='customer-service-box'>
                                                            <Col xs={24} md={24}>
                                                                <Collapse
                                                                    expandIconPosition="end"
                                                                    ghost
                                                                    defaultActiveKey={[]}
                                                                >
                                                                    <Panel
                                                                        header={<><span className="font-weight-500"><FolderOutlined /> Lần khám</span></>}
                                                                        key="1"
                                                                    >
                                                                        {
                                                                            item?.examination_visit && item?.examination_visit.length ? (
                                                                                <>
                                                                                    <Row gutter={16}>
                                                                                        {item.examination_visit.map((item2, index2) => {
                                                                                            return (
                                                                                                <div key={index2} style={{ borderBottom: '1px solid #dedede' }} className='mb-2 pb-2'>
                                                                                                    <Col xs={24} md={24}>
                                                                                                        <Descriptions size="small">
                                                                                                            <Descriptions.Item label="Thời điểm">
                                                                                                                {isValidDate(item2.time)}
                                                                                                            </Descriptions.Item>
                                                                                                        </Descriptions>
                                                                                                    </Col>
                                                                                                    <Col xs={24} md={24}>
                                                                                                        <Descriptions size="small">
                                                                                                            <Descriptions.Item label="Bác sĩ">
                                                                                                                {item2.doctor_charge_id}
                                                                                                            </Descriptions.Item>
                                                                                                        </Descriptions>
                                                                                                    </Col>
                                                                                                    <Col xs={24} md={24}>
                                                                                                        <Descriptions size="small">
                                                                                                            <Descriptions.Item label="Phụ tá">
                                                                                                                {item2.assistant_doctor_id}
                                                                                                            </Descriptions.Item>
                                                                                                        </Descriptions>
                                                                                                    </Col>
                                                                                                    <Col xs={24} md={24}>
                                                                                                        <div className="font-weight-500">Kết quả khám:</div>
                                                                                                        {HtmlParser(item.note)}
                                                                                                    </Col>
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                    </Row>
                                                                                </>
                                                                            ) : (
                                                                                <Row gutter={16}><div style={{ textAlign: 'center', width: '100%' }} className='no-data'>Chưa có dữ liệu</div></Row>
                                                                            )
                                                                        }
                                                                    </Panel>
                                                                </Collapse>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16} className='customer-service-box'>
                                                            <Col xs={24} md={24}>
                                                                <Collapse
                                                                    expandIconPosition="end"
                                                                    ghost
                                                                    defaultActiveKey={[]}
                                                                >
                                                                    <Panel
                                                                        header={<><span className="font-weight-500"><UserOutlined /> Nhân viên tư vấn</span></>}
                                                                        key="1"
                                                                    >
                                                                        {
                                                                            item?.consultant_directly && item?.consultant_directly.length ? (
                                                                                <>
                                                                                    <Row gutter={16}>
                                                                                        {
                                                                                            item?.consultant_directly.map((item2, index) => {
                                                                                                return (
                                                                                                    <div key={index} style={{ borderBottom: '1px solid #dedede' }} className='mb-2 pb-2'>
                                                                                                        <Col xs={24} md={24}>
                                                                                                            <Descriptions size="small">
                                                                                                                <Descriptions.Item label="Nhân viên">
                                                                                                                    {item2.consultant_user}
                                                                                                                </Descriptions.Item>
                                                                                                            </Descriptions>
                                                                                                        </Col>
                                                                                                        <Col xs={24} md={24}>
                                                                                                            <Descriptions size="small">
                                                                                                                <Descriptions.Item label="Thời điểm">
                                                                                                                    {isValidDate(item2.consultant_date)}
                                                                                                                </Descriptions.Item>
                                                                                                            </Descriptions>
                                                                                                        </Col>
                                                                                                        <Col xs={24} md={24}>
                                                                                                            <div className="font-weight-500">Kết quả tư vấn:</div>
                                                                                                            {HtmlParser(item2.note)}
                                                                                                        </Col>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }
                                                                                    </Row>
                                                                                </>) : (
                                                                                <Row gutter={16}><div style={{ textAlign: 'center', width: '100%' }} className='no-data'>Chưa có dữ liệu</div></Row>
                                                                            )
                                                                        }
                                                                    </Panel>
                                                                </Collapse>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={16} className='mt-2'>
                                                            <Col xs={24} md={24}>
                                                                <Text strong>Ghi chú: </Text>
                                                                <ExpandableText
                                                                    text={item.note}
                                                                    rows={2}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            )
                                        })}
                                </Row>
                            ) : null}
                        </>
                    ) : null
                }
                <CustomerServiceAddForm
                    visible={isOpenAddForm}
                    currentData={currentData}
                    currentCustomer={currentCustomer}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <CustomerServiceEditForm
                    visible={isOpenEditForm}
                    currentData={currentData}
                    currentCustomer={currentCustomer}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenEditForm(false)}
                />
                <CustomerServiceConvertForm
                    visible={isOpenConvertForm}
                    currentData={currentData}
                    currentCustomer={currentCustomer}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenConvertForm(false)}
                />
            </div >
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser,
        branchActiveList: state.BranchReducer.branchActiveList
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeService: (ids) => dispatch(removeService(ids)),
        getSpecificService: (id) => dispatch(getSpecificService(id))
    }
}

// export default connect(mapStateToProps, mapDispatchToProps)(CustomerServicesList);

// Sử dụng forwardRef để truyền ref xuống component
// Mục đích để cho parent component có thể gọi method của child component
const ConnectedCustomerServicesSelected = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(CustomerServicesList);

export default React.forwardRef((props, ref) => (
    <ConnectedCustomerServicesSelected {...props} ref={ref} />
));
